/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import { alias } from '@ember/object/computed';
import type { Type } from '@warp-drive/core/types/symbols';
import { fragment } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type NotificationType from '@linc-technologies/linced-common/enums/notification-type';
import type Fragment from 'ember-data-model-fragments/fragment';
import type School from '@linc-technologies/linced-common/models/school';

// Proto: notifications.Notification.
export default class Notification extends Model {
  declare [Type]: 'notifications/notification';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  @alias('schoolId')
  declare school: AsyncBelongsTo<School>;

  // TODO: Update when we implement Campuses.
  @attr('string', { defaultValue: '' })
  declare campusId: string;

  @attr('number', { defaultValue: 0 })
  declare notificationType: EnumValue<typeof NotificationType>;

  @attr('string', { defaultValue: '' })
  declare entityId: string;

  @attr('number')
  declare scheduleTime: number | undefined;

  // TS-STANDIN(notifications/params): each app has its own params fragment.

  @fragment('notifications/params')
  declare params: Fragment | null;
}
